<template lang="pug"></template>

<script>
export default {
    name: 'BotaoDenuncia',
    componentOptions: {
        title: 'Denúncias',
        actions: [
            [
                {
                    name: 'Denúncias',
                    iconClass: 'mdi mdi-alert denuncia-icon',
                    action: 'abrir',
                    route: 'denuncias',
                    nameTranslationKey: 'mensagens.menuLateral.denuncia'
                }
            ]
        ]
    },

    methods: {
        abrirDenuncia() {
            if (this.$route.name !== 'denuncia') {
                this.$router.push({ name: 'denuncia' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
